const NetworkTableParser = {};

NetworkTableParser.getNetworkTableParser = (res) => {
  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }
};

// *******post*******
NetworkTableParser.postAddChargingNetworkparser = (res) => {

  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }
};

export { NetworkTableParser };
